// extracted by mini-css-extract-plugin
module.exports = {"component":"LanguageModal_component__sgub6"};